import { CmsApiFreeCodeBlockData } from 'modules/cms/api/types/CmsApiFreeCode';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsFreeCodeBlock } from './CmsFreeCodeBlock';

export const CmsFreeCodeBlockMapping: CmsBlockMapping<CmsApiFreeCodeBlockData> =
  {
    invariant: [
      {
        prop: 'code',
        msg: 'Code required',
      },
    ],
    width: CmsBlockWidth.INSET,
    Component: CmsFreeCodeBlock,
    // @ts-expect-error TS(2322): Type 'null' is not assignable to type '(props: Cms... Remove this comment to see the full error message
    AmpComponent: null,
  };
